function GetImageURL(name) {
    return require(`../Assets/Images/${name}.png`)
}

export default GetImageURL;